/**
 * @file Contains the loading component displayed when the app is loading.
 */
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

export default function Loading({ message = 'Loading…', ...rest }) {
  return (
    <Stack
      sx={{ color: 'grey.500', padding: '0.3rem 0', ...rest }}
      spacing={2}
      direction="row"
      useFlexGap
      alignItems="center"
    >
      <CircularProgress color="secondary" /> {message}
    </Stack>
  );
}

Loading.propTypes = {
  message: PropTypes.string,
};
